import React, { useEffect, useRef, useState } from "react";
import Credin from "../../assets/Credin Logo (1).svg";
import Logo from "../../assets/logocopy.png";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import { url } from "../../App";
import { useNavigate } from "react-router-dom";

export default function Page5() {
  var base64 = require("base-64");
  const [open, setOpen] = React.useState(false);
  const [selfie, setSelfie] = useState([]);
  // const [upload, setUpload] = useState(false);
 // eslint-disable-next-line
  const [pdfData, setPdfData] = useState("");
  const [isFrontFacing, setIsFrontFacing] = useState(true);
  const [satelliteImages, setSatelliteImages] = useState("");

  const newFacingMode = isFrontFacing ? 'environment' : 'user';
  const navigate = useNavigate();
  let videoRef = useRef(null);
  let photoRef = useRef(null);

  const takePicture = () => {
    if (selfie.length >= 8) {
      toast.error("Only 8 pictures Required");
      return;
    }
    console.log(selfie.length);
    let width = 500;
    let height = width / (16 / 9);
    let photo = photoRef.current;
    let video = videoRef.current;
    photo.height = height;
    let ctx = photo.getContext("2d");
    ctx.drawImage(video, 0, 0, photo.width, photo.height);
    var image = photo.toDataURL("image/*");
    console.log(image);
    setSelfie((oldArray) => [...oldArray, image]);
  };

  useEffect(() => {
    const SatelliteImages = localStorage.getItem("SatelliteImages");
    console.log(SatelliteImages)
    setSatelliteImages(SatelliteImages);
    const getUserCamera = () => {
      navigator.mediaDevices
        .getUserMedia({
          video: {
            facingMode: newFacingMode,
            width: { ideal: 640 },
            height: { ideal: 480 },
          },
          audio: false,
        })
        .then((stream) => {  
          let video = videoRef.current;
          video.srcObject = stream;
          setTimeout(() => {
            video.play();
          }, 150);
        })
  
        .catch((err) => {
          toast.error("Please give access to camera");
          console.log(err);
        });
        console.log(newFacingMode);
    };
  
    getUserCamera();

  }, [videoRef,newFacingMode]);

  const generatePdf = () => {
    setOpen(true);
    if (selfie.length <= 3) {
      setOpen(false);
      toast.error("Please take at least 4 Pictures");
      return;
    }
    const doc = new jsPDF({ compress: true });
    doc.addImage(Logo, "png", 15, 10, 40, 15, undefined, "FAST");
    doc
      .setFontSize(16)
      .text(
        localStorage.getItem("VerificationTypeCPV") + " Verification",
        100,
        20
      );
    doc
      .setFontSize(12)
      .text(
        `Verification Agent Name - ${localStorage.getItem("NameCPV")}`,
        100,
        28
      );
    doc
      .setFontSize(12)
      .text(
        "Verification Agent Code -" + localStorage.getItem("CodeCPV"),
        100,
        34
      );
    doc.autoTable({
      margin: { top: 40, left: 15, minCellWidth: "auto" },
      styles: {
        overflow: "linebreak",
        fontSize: 12,
        valign: "middle",
      },
      head: [["Customer Details", ""]],
      body: [
        // ["Loan Id", localStorage.getItem("LoanIdCPV")],
         ["Unique Id", localStorage.getItem("BorrowerUniqueNoCPV")],
        ["Borrower Name", localStorage.getItem("BorrowerNameCPV")],
        ["Father Name", localStorage.getItem("BorrowerFatherNameCPV")],
        ["Borrower Address", localStorage.getItem("BorrowerAddressCPV")],
        ["Contact Number", localStorage.getItem("BorrowerMobileCPV")],
        ["City", localStorage.getItem("BorrowerCityCPV")],
        ["State", localStorage.getItem("BorrowerStateCPV")],
        ["Pin Code", localStorage.getItem("BorrowerPincodeCPV")],
        ["Customer Type", localStorage.getItem("CustomerTypeCPV")],
        ["Verification Type", localStorage.getItem("VerificationTypeCPV")],
      ],
    });
    if (localStorage.getItem("VerificationTypeCPV") === "Residence") {
      doc.autoTable({
        margin: { top: 50, left: 15, minCellWidth: "auto" },
        styles: {
          overflow: "linebreak",
          fontSize: 12,
          valign: "middle",
        },
        head: [["Interview Details", ""]],
        body: [
          [
            "Company / Business Description ",
            localStorage.getItem("CompanyBusinessDescriptionCPV"),
          ],
          [
            "Company / Business Priority",
            localStorage.getItem("CompanyBusinessPriorityCPV"),
          ],
          ["Visit Conducted", localStorage.getItem("VisitConductedCPV")],
          ["Address Confirmed", localStorage.getItem("AddressConfirmationCPV")],
          [
            "If Address not confirmed",
            localStorage.getItem("IfAddressNotConfirmCPV"),
          ],
          ["Address Trace", localStorage.getItem("AddressTraceCPV")],
          ["Landmark", localStorage.getItem("LandmarkCPV")],
          ["Met Person Name", localStorage.getItem("MetPersonNameCPV")],
          ["Met Person Relation", localStorage.getItem("MetPersonRelationCPV")],
          ["Ownership", localStorage.getItem("OwnershipCPV")],
          [
            "If Rented (Rent Amt. & Landlord Name)",
            localStorage.getItem("IfRentedCPV"),
          ],
        ],
      });
      doc.addPage();
      doc.autoTable({
        margin: { top: 25, left: 15, minCellWidth: "auto" },
        styles: {
          overflow: "linebreak",
          fontSize: 12,
          valign: "middle",
        },
        head: [["Interview Details", ""]],
        body: [
          ["Stability Years", localStorage.getItem("StabilityYearsCPV")],
          ["Marital Status", localStorage.getItem("MaritalStatusCPV")],
          ["No. of Children", localStorage.getItem("ChildCPV")],
          ["Total Members", localStorage.getItem("TotalMembersCPV")],
          ["Earning Members", localStorage.getItem("EarningMembersCPV")],
          ["Spouse Name", localStorage.getItem("SpouseNameCPV")],
          ["Standard Of Living", localStorage.getItem("StandardOfLivingCPV")],
          ["Name Plate", localStorage.getItem("NamePlateCPV")],
          ["Number of Rooms", localStorage.getItem("TotalRoomCPV")],
          [
            "Applicant Resides At",
            localStorage.getItem("ApplicantResideAtCPV"),
          ],
          ["Locality", localStorage.getItem("LocalityCPV")],
          ["TPC 1", localStorage.getItem("Tpc1CPV")],
          ["TPC 1 Remarks", localStorage.getItem("TpcRemarks1CPV")],
          ["TPC 2", localStorage.getItem("Tpc2CPV")],
          ["TPC 2 Remarks", localStorage.getItem("TpcRemarks2CPV")],
          ["Additional Remarks", localStorage.getItem("AdditionalRemarksCPV")],
        ],
      });
    }
     else if (localStorage.getItem("VerificationTypeCPV") === "Office/Business"){
      doc.autoTable({
        margin: { top: 50, left: 15, minCellWidth: "auto" },
        styles: {
          overflow: "linebreak",
          fontSize: 12,
          valign: "middle",
        },
        head: [["Interview Details", ""]],
        body: [
          [
            "Office / Business",
            localStorage.getItem("OfficeOrBusinessDescriptionCPV"),
          ],
          ["Office / Business Description", localStorage.getItem("OfficeOrBusinessCPV")],
          ["Visit Conducted", localStorage.getItem("VisitConductedCPV")],
          ["Address Confirmed", localStorage.getItem("AddressConfirmationCPV")],
          [
            "If Address not confirmed",
            localStorage.getItem("IfAddressNotConfirmCPV"),
          ],
          ["Address Traced", localStorage.getItem("AddressTraceCPV")],
          ["Landmark", localStorage.getItem("LandmarkCPV")],
          ["Met Person Name", localStorage.getItem("MetPersonNameCPV")],
          [
            "Met Person Designation",
            localStorage.getItem("MetPersonDesignationCPV"),
          ],
          ["Ownership", localStorage.getItem("OwnershipCPV")],
          [
            "Applicant Designation",
            localStorage.getItem("ApplicantDesignationCPV"),
          ],
        ],
      });
      doc.addPage();
      doc.autoTable({
        margin: { top: 25, left: 15, minCellWidth: "auto" },
        styles: {
          overflow: "linebreak",
          fontSize: 12,
          valign: "middle",
        },
        head: [["Interview Details", ""]],
        body: [
          ["Working Years", localStorage.getItem("WorkingYearsCPV")],
          ["Salary / Income", localStorage.getItem("SalaryCPV")],
          ["Employee ID", localStorage.getItem("EmployeeIdCPV")],
          ["Nature Of Business", localStorage.getItem("NatureOfBusinessCPV")],
          ["Total Employees", localStorage.getItem("TotalEmployeeCPV")],
          ["Employee Seen", localStorage.getItem("EmployeeSeenCPV")],
          ["Office Setup", localStorage.getItem("OfficeSetupCPV")],
          ["Total Floors", localStorage.getItem("TotalFloorCPV")],
          ["Applicant Office At", localStorage.getItem("ApplicantOfficeAtCPV")],
          ["Office Area", localStorage.getItem("OfficeAreaCPV")],
          ["Locality", localStorage.getItem("LocalityCPV")],
          ["TPC 1", localStorage.getItem("Tpc1CPV")],
          ["TPC 1 Remarks", localStorage.getItem("TpcRemarks1CPV")],
          ["TPC 2", localStorage.getItem("Tpc2CPV")],
          ["TPC 2 Remarks", localStorage.getItem("TpcRemarks2CPV")],
          ["Additional Remarks", localStorage.getItem("AdditionalRemarksCPV")],
        ],
      });
    }
    //ResiCumBusiness logic
    else{
      doc.autoTable({
        margin: { top: 50, left: 15, minCellWidth: "auto" },
        styles: {
          overflow: "linebreak",
          fontSize: 12,
          valign: "middle",
        },
        head: [["Interview Details", ""]],
        body: [
          [
            "Company / Business Description",
            localStorage.getItem("CompanyBusinessDescriptionCPV"),
          ],
          [
            "Please Describe Your Business",
            localStorage.getItem("businessDescription"),
          ],
          [
            "If Address not confirmed",
            localStorage.getItem("IfAddressNotConfirmCPV"),
          ],
          ["Landmark", localStorage.getItem("LandmarkCPV")],
          ["Meeting With", localStorage.getItem("meetingWith")],
          ["Met Person Name", localStorage.getItem("MetPersonNameCPV")],
          [
            "Met Person Relation",
            localStorage.getItem("MetPersonRelationCPV"),
          ],
          ["Ownership", localStorage.getItem("OwnershipCPV")],
        ],
      });
      doc.addPage();
      doc.autoTable({
        margin: { top: 25, left: 15, minCellWidth: "auto" },
        styles: {
          overflow: "linebreak",
          fontSize: 12,
          valign: "middle",
        },
        head: [["Interview Details", ""]],
        body: [
          ["If Rented (Rent Amt. & Landlord Name)", localStorage.getItem("IfRentedCPV")],
          ["Landlord Name", localStorage.getItem("landlordName")],
          ["Landlord Mobile", localStorage.getItem("landlordMobile")],
          ["Stability Years", localStorage.getItem("StabilityYearsCPV")],
          ["Name Plate", localStorage.getItem("NamePlateCPV")],
          ["House Type", localStorage.getItem("houseType")],
          ["Total Room", localStorage.getItem("TotalRoomCPV")],
          ["TPC 1 Name", localStorage.getItem("Tpc1CPV")],
          ["TPC 1 Mobile", localStorage.getItem("TpcRemarks1CPV")],
          ["TPC 2 Name", localStorage.getItem("Tpc2CPV")],
          ["TPC 2 Mobile", localStorage.getItem("TpcRemarks2CPV")],
          ["Additional Remarks", localStorage.getItem("AdditionalRemarksCPV")],
        ],
      });
    }
    doc.autoTable({
      margin: { top: 25, left: 15, minCellWidth: "auto" },
      styles: {
        overflow: "linebreak",
        fontSize: 12,
        valign: "middle",
      },
      head: [["Summary", ""]],
      body: [
        ["Final Remark", localStorage.getItem("FinalRemarkCPV")],
        [
          "Description / Summary",
          localStorage.getItem("DescriptionSummaryCPV"),
        ],
        ["Longitude", localStorage.getItem("LongitudeCPV")],
        ["Latitude ", localStorage.getItem("LatitudeCPV")],
        ["Time", localStorage.getItem("AllocatedOnCPV")],
        ["Near By Address", localStorage.getItem("LocationDetailsCPV")],
        [
          "Distance from the branch",
          localStorage.getItem("DistanceFromBranchCPV"),
        ],
      ],
    });
    doc.addPage();
    doc.addImage(selfie[0], "png", 15, 15, 50, 40, "one", "FAST");
    doc.addImage(selfie[1], "png", 80, 15, 50, 40, "two", "FAST");
    doc.addImage(selfie[2], "png", 145, 15, 50, 40, "three", "FAST");
    doc.addImage(selfie[3], "png", 15, 75, 50, 40, "four", "FAST");
    if (selfie[4] !== undefined) {
      doc.addImage(selfie[4], "png", 80, 75, 50, 40, "five", "FAST");
      if (selfie[5] !== undefined) {
        doc.addImage(selfie[5], "png", 145, 75, 50, 40, "six", "FAST");
        if (selfie[6] !== undefined) {
          doc.addImage(selfie[6], "png", 15, 130, 50, 40, "seven", "FAST");
          if (selfie[7] !== undefined) {
            doc.addImage(selfie[7], "png", 80, 130, 50, 40, "eight", "FAST");
          }
        }
      }
    }
    doc.addPage();
    doc
    .setFontSize(14)
    .text(
      "Satellite Image",
      85,
      25
    );
    doc.addImage(satelliteImages, "png", 40, 40, 125, 75, "nine", "FAST");
    doc.save(
      "CPV_" +
        localStorage.getItem("VerificationTypeCPV") +
        ".pdf"
    );
    var out = doc.output();
    var outdata = base64.encode(out);
    console.log(outdata);
    setPdfData(outdata);
    // setUpload(true);
    // setOpen(false);

//auto trigger api

    // if (upload === false) {
    //   setOpen(false);
    //   toast.error("Please Generate PDF First");
    //   return;
    // }
    // console.log("Uploading");
    axios
      .post(url + "/api/add/cpv", {
        mobileNumber: localStorage.getItem("number"),
        cpvPdf: outdata,
        createdBy: localStorage.getItem("CodeCPV"),
        verificationType: localStorage.getItem("VerificationTypeCPV"),
        finalReview: localStorage.getItem("FinalRemarkCPV"),
      })
      .then((res) => {
        console.log(res);
        if (res.data.auth === true) {
          setOpen(false);
          toast.success(res.data.msg);
          setTimeout(() => {
            // localStorage.clear();
            navigate("/1");
          }, 3000);
        } else {
          setOpen(false);
          toast.error(res.data.msg);
        }
      })
      .catch((err) => {
        setOpen(false);
        toast.error(err.message);
        console.log(err);
      });

  };

  // const handleUpload = () => {
  //   setOpen(true);
  //   console.log(upload);
  //   if (upload === false) {
  //     setOpen(false);
  //     toast.error("Please Generate PDF First");
  //     return;
  //   }
  //   console.log("Uploading");
  //   axios
  //     .post(url + "/api/add/cpv", {
  //       uniqueId: localStorage.getItem("LoanIdCPV"),
  //       cpvPdf: pdfData,
  //       createdBy: localStorage.getItem("CodeCPV"),
  //       verificationType: localStorage.getItem("VerificationTypeCPV"),
  //       finalReview: localStorage.getItem("FinalRemarkCPV"),
  //     })
  //     .then((res) => {
  //       console.log(res);
  //       if (res.data.auth === true) {
  //         setOpen(false);
  //         toast.success(res.data.msg);
  //         setTimeout(() => {
  //           navigate("/1");
  //         }, 3000);
  //       } else {
  //         setOpen(false);
  //         toast.error(res.data.msg);
  //       }
  //     })
  //     .catch((err) => {
  //       setOpen(false);
  //       toast.error(err.message);
  //       console.log(err);
  //     });
  // };

  const handleCamera = () => {
    setIsFrontFacing(!isFrontFacing);
  }

  return (
    <div className="main-login">
      <div style={{ margin: "2rem" }}>
        <img src={Credin} alt="Credin Logo" width="150" />
      </div>
      <div className="container-login">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <video ref={videoRef} width={350}></video>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: ".5rem 0",
          }}
        >
          <button className="btn-login" onClick={takePicture}>
            Take Picture
          </button>
          <button className="btn-login" style={{ margin: "0 .5rem" }} onClick={handleCamera}>
            Switch Camera
          </button>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <canvas ref={photoRef}/>
        </div>
         {/* // to show multiple images in ui */}
        {/* <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", marginTop: "20px" }}>
          {selfie.map((imgSrc, index) => (
            <img
              key={index}
              src={imgSrc}
              alt={`selfie-${index}`}
              style={{ width: "250px", height: "auto", margin: "10px", borderRadius: "10px" }}
            />
          ))}
        </div> */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: ".5rem 0",
          }}
        >
          <button onClick={generatePdf} className="btn-login">
            Generate PDF
          </button>
          {/* <button
            className="btn-login"
            style={{ margin: "0 .5rem" }}
            onClick={handleUpload}
          >
            Upload PDF
          </button> */}
        </div>
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
}
